//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('TwitterSettingsService', [
    '$http',
    'PromiseService',
    function(
            $http,
            PromiseService,
        ) {
      const BASE_URL = '/api/settings/twitter';

      this.getTwitterSettings = function() {
        return PromiseService.processHttpResponse($http.get(BASE_URL));
      };

            // Twitter Account Oauth/Deauth

      this.getTwitterOAuthEndpoint = function() {
        return PromiseService.processHttpResponse($http.get(`${BASE_URL}/oauth`));
      };

      this.handleTwitterOAuthResponse = function() {
        return PromiseService.processHttpResponse($http.get(`${BASE_URL}/oauth/response`));
      };

      this.deauthTwitter = function(username) {
        return PromiseService.processHttpResponse($http.post(`${BASE_URL}/deauth/${username}`));
      };
    },
  ]);
})();
